import { Component, Input } from '@angular/core';
import { InlineMessageVariant, InlineMessageAligment, ICON_NAME_MAP } from './inline-message.model';

@Component({
  selector: 'miq-inline-message',
  templateUrl: './inline-message.component.html',
  styleUrls: ['./inline-message.component.scss'],
  standalone: false,
})
export class InlineMessageComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() variant = InlineMessageVariant.info;
  @Input() customClass = '';
  @Input() customIconName = '';
  @Input() contentAligment = InlineMessageAligment.left;

  public iconNameMap = ICON_NAME_MAP;
}
